import React from 'react';
import { observer } from 'mobx-react';
import { ScheduleListTemplate } from 'themes/application/schedule/pages';
import { setCurrentView } from 'core/utils';
import { ScheduleViewStore } from 'application/schedule/stores';

@setCurrentView((rootStore) => new ScheduleViewStore(rootStore), 'listViewStore')
@observer
class ScheduleList extends React.Component {
    render() {
        return <ScheduleListTemplate {...this.props} />
    }
}

export default ScheduleList;